import { getLocalStorageObject } from '@/helpers/LocalStorageHelper'
import { Authentication, Role } from '@/constants/DoITConstant'
import { USER_AUTH, USER_IMPORT, USER_INFO, USER_PROFILE } from '@/config/config_api_backend'
import http from '../plugins/http'

const apiGetAllUser = async (params) => {
  try {
    let response = await http.get(USER_PROFILE.GET_ALL, {
      params: params,
    })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

const getRolesUserCurrent = () => {
  const userInfo = getLocalStorageObject(Authentication.USER_INFO)
  // console.log('userInfo ', userInfo)
  if (userInfo != null && userInfo['roles'] != null) {
    return userInfo['roles']
  }

  return []
}

const hasRoleAdmin = () => {
  const rolesCurrent = getRolesUserCurrent()
  // console.log('rolesCurrent ', rolesCurrent)
  // console.log('isAdmin', rolesCurrent.includes(Role.ROLE_ADMIN))
  return rolesCurrent.includes(Role.ROLE_ADMIN)
}

const hasRoleTeacher = () => {
  const rolesCurrent = getRolesUserCurrent()
  return rolesCurrent.includes(Role.ROLE_TEACHER)
}

const hasRoleStudent = () => {
  const rolesCurrent = getRolesUserCurrent()
  return rolesCurrent.includes(Role.ROLE_TEACHER)
}

const hasRoleUser = () => {
  const rolesCurrent = getRolesUserCurrent()
  return rolesCurrent.includes(Role.ROLE_USER)
}

const updateInfo = async (data) => {
  try {
    let response = await http.post(USER_PROFILE.UPDATE_INFO, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

export const updateSubscription = async (data) => {
  let response = await http.post(USER_PROFILE.UPDATE_SUBSCRIPTION, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

export const updateCredit = async (data) => {
  let response = await http.post(USER_PROFILE.UPDATE_CREDIT, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

const createUser = async (data) => {
  let response = await http.put(USER_AUTH.CREATE, JSON.stringify(data), {
    headers: {
      'Content-Type': 'application/json',
    },
  })
  return response.data
}

const updateProfile = async (data) => {
  try {
    let response = await http.post(USER_PROFILE.UPDATE, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

const apiGetUserExportFileAsArrayBuffer = async () => {
  try {
    let response = await http.get(USER_PROFILE.EXPORT_EXCEL,
      {
        responseType: 'arraybuffer'
      })
    return response.data
  } catch (e) {
    console.log(e)
    return null
  }
}

export {
  getRolesUserCurrent,
  hasRoleAdmin,
  hasRoleStudent,
  hasRoleTeacher,
  hasRoleUser,
  updateProfile,
  apiGetAllUser,
  updateInfo,
  createUser,
  apiGetUserExportFileAsArrayBuffer
}
